<template>
  <v-row justify-center>
    <v-form v-model="valid" id="valid" ref="form">
    <v-dialog :value="value" @input="$emit('input')" max-width="450">
      <v-card>
        <v-card-title class="headline">{{ localization.nuevaNota }}</v-card-title>
        <v-card-text text-xs-center class="text-xs-center">
          <v-flex xs12 pl-3 pr-3>
            <v-menu v-model="menuFecha" id="menuFecha" :close-on-content-click="false"
              :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="fechaFormateada" id="fechaFormateada"
                  :label="localization.fecha"
                  :rules="[rules.obligatorio]"
                  prepend-icon="event" v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="fechaAnnotation" id="fechaAnnotation" @input="menuFecha = false"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-text-field v-model="annotationText" id="annotationText" :rules="[rules.obligatorio]" :label="localization.nota"></v-text-field>


          <v-checkbox
            v-model="addAllIncidences" id="addAllIncidences"
            :label="localization.addAllIncidences"
            color="primary"
            hide-details
          />

        </v-card-text>
        <v-card-actions class="justify-center">
          <v-spacer></v-spacer>
          <v-btn text @click.native="$emit('input')">{{ localization.cancelar }}</v-btn>
          <v-btn color="primary" :loading="saving" :disabled="saving" text @click="add()">{{localization.añadir}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-form>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
import rulesMixin from '@/components/generic/rules.js'
import moment from 'moment'

export default {
  mixins: [rulesMixin],
  props: {
    value: Boolean,
    incidence: String
  },
  data () {
    return {
      menuFecha: false,
      fechaAnnotation: new Date().toISOString().substr(0, 10),
      addAllIncidences: false,
      annotationText: '',
      valid: true,
      saving: false
    }
  },
  computed: {
    fechaFormateada () {
      return (this.fechaAnnotation) ? moment(this.fechaAnnotation, 'YYYY-MM-DD').format('DD/MM/YYYY') : null
    },
    localization () {
      return this.$t('addAnnotation')
    }
  },
  methods: {
    ...mapActions({
      addAnnotation: 'incidencias/addAnnotation',
      getAnnotations: 'incidencias/getAnnotations',
      addAlert: 'alerts/add'
    }),
    async add () {
      this.$refs.form.validate()
      if (!this.valid) {
        this.addAlert({texto: this.$t("revisarCamposRojo"), color: 'error'})
      } else {
        this.saving = true
        try {
          const values = {}
          values.annotation = this.annotationText
          values.date = this.fechaAnnotation
          values.incidenceId = this.incidence
          values.addAllIncidences = this.addAllIncidences
          await this.addAnnotation(values)
          this.getAnnotations(this.incidence)
          this.fechaAnnotation = ''
          this.annotationText = ''
          this.$emit('input')
        } catch (error) {
          // eslint-disable-next-line
        } 
      }
      this.saving = false
    }
  }
}
</script>